import { dappStore, userStore } from '@components/store';
import React, { useEffect } from 'react';
import { useAccount, useBalance, useNetwork, useProvider, useSigner } from 'wagmi';
import { useWeb3Methods } from './useWeb3Methods';
import { useAddresses, useContractsLoaded } from '@components/store/getters';
import mixpanel from 'mixpanel-browser';

export const useWalletConnection = () => {
  const { address, isConnected } = useAccount();
  const provider = useProvider();
  const { data } = useBalance({ address });
  const { data: signer } = useSigner();
  const { chain } = useNetwork();
  const {
    loadContracts,
    updateAddresses,
    updateUserBalances,
    createEventTriggers,
    updateUserPositions,
    updateApprovalStatus,
  } = useWeb3Methods();
  const addresses = useAddresses();
  const contractsLoaded = useContractsLoaded();

  // This is called after connected and contracts are loaded
  const updateConnectedState = () => {
    userStore.setState({
      balanceEth: parseFloat(data?.formatted).toFixed(3),
      userAddress: address,
      network: chain?.name,
      networkID: chain?.id?.toString(),
    });
  };

  useEffect(() => {
    if (provider) {
      userStore.setState({ provider });
      createEventTriggers();
      updateAddresses();
    }
  }, [provider]);

  useEffect(() => {
    if (chain) dappStore.setState({ isWrongNetwork: chain.unsupported });
  }, [chain]);

  useEffect(() => {
    if (addresses && signer && !chain?.unsupported) {
      userStore.setState({ signer });
      loadContracts();
    }
  }, [addresses, signer]);

  useEffect(() => {
    if (address) mixpanel.identify(address);
  }, [address]);

  useEffect(() => {
    const setupAppAfterConnection = async () => {
      if (isConnected && !chain?.unsupported) {
        await updateApprovalStatus();
        if (contractsLoaded) {
          updateConnectedState();
          await updateUserBalances();
          await updateUserPositions();
        }
      }
    };
    setupAppAfterConnection();
  }, [isConnected, contractsLoaded]);
};
